import config from '../config'
import { find } from 'lodash/collection'

const retrieveToken = () => {
  return localStorage.getItem('token')
}

export const findValidUser = (userId) => {
  return find(config.allowedUsers, { id: parseInt(userId, 10) })
}

export const login = (config, username, password, authCtx) => {
  const url = config.vimondApi + '/api/authentication/user/login'
  let headers

  const data = new URLSearchParams({
    username: username.trim(),
    password: password.trim(),
    rememberMe: true
  });

  return fetch(
    url,
    {
      method: 'POST',
      mode: 'cors',
      body: data.toString(),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  ).then((res) => {
    headers = res.headers
    if (res.ok) {
      return res.json()
    } else {
      return res.json().then((data) => {

        let errorMessage = 'Authentication failed!'
        if (data && data.error && data.error.message) {
          errorMessage = data.error.message
        }
        return errorMessage
      })
    }
  }).then((data) => {
    if (data.response.code === 'AUTHENTICATION_FAILED') {
      return {
        error: data.response.code
      }
    }
    const auth = headers.get('Authorization');
    let token = ''
    if (auth) {
      token = auth.split(/, +/)[0]
    }
    const validUser = authCtx.checkUser(data.response.userId, token)
    if (validUser) {
      return validUser
    } else {
      return {
        error: 'INVALID_USER'
      }
    }
  }).catch((err) => {
    alert(err.message)
  })
}

export const doNordicLogin = (userId, token, authCtx) => {
  const validUser = authCtx.checkUser(userId, token)
  if (validUser) {
    return validUser
  } else {
    return {
      error: 'INVALID_USER'
    }
  }
}

export const authenticateSession = (config, authCtx) => {
  const token = retrieveToken()
  if (token) {
    // try to authenticate
    fetch(
      'https://fin.account.a2d.tv/rest/user/me?client=mtv-web',
      {
        mode: 'cors',
        headers: {
          Accept: 'application/json;charset=utf-8',
          'Content-type': 'application/json;v=2',
          Authorization: `Bearer ${token}`
        }
      }
    ).then((resp) => {
      if (resp.status === 200) {
        return resp.json()
      } else {
        authCtx.login(null)
        return null
      }
    }).then((json) => {
      if (json) {
        const validUser = findValidUser(json.userId)
        if (validUser) {
          authCtx.login(retrieveToken(), validUser.role)
        } else {
          authCtx.login(null)
        }
      }
    })
  } else {
    // if no token stored, proceed to showing login form
    authCtx.login(null)
  }
}
